"use strict";

exports.__esModule = true;
exports.ConditionTypePopup = void 0;
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
var _TranslatorContext = require("../../Core/Translator/TranslatorContext");
var _Theme = require("../../Theme");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("../constants");
var _styles = require("../styles");
var _vimanaTypes = require("@vimana/vimana-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ConditionTypeContainer = _styledComponents["default"].div.withConfig({
  displayName: "ConditionTypePopup__ConditionTypeContainer",
  componentId: "sc-szfrba-0"
})(["position:relative;padding:", ";min-width:200px;"], (0, _Theme.val)("padding"));
var FormLabel = _styledComponents["default"].div.withConfig({
  displayName: "ConditionTypePopup__FormLabel",
  componentId: "sc-szfrba-1"
})(["font-weight:", ";margin-bottom:5px;"], (0, _Theme.val)("fontWeightHeavy"));
var FooterButtons = _styledComponents["default"].div.withConfig({
  displayName: "ConditionTypePopup__FooterButtons",
  componentId: "sc-szfrba-2"
})(["display:flex;justify-content:flex-end;margin-top:1em;.resetForm{margin-right:1em;}"]);
var ConditionTypePopup = exports.ConditionTypePopup = function ConditionTypePopup(_ref) {
  var conditions = _ref.conditions,
    setConditionArray = _ref.setConditionArray,
    onClose = _ref.onClose;
  var _useContext = (0, _react.useContext)(_TranslatorContext.TranslatorContext),
    translate = _useContext.translate;
  var _useState = (0, _react.useState)(_constants.ConditionTypes[0]),
    selectedType = _useState[0],
    setSelectedType = _useState[1];
  return /*#__PURE__*/_react["default"].createElement(ConditionTypeContainer, null, /*#__PURE__*/_react["default"].createElement(FormLabel, null, translate("EnrichEditorUI.ConditionTypePopup.ChooseConditionType", "Choose condition type")), /*#__PURE__*/_react["default"].createElement(_styles.FlexRow, null, /*#__PURE__*/_react["default"].createElement("span", null, translate("EnrichEditorUI.ConditionTypePopup.ClassifyType", "Type")), /*#__PURE__*/_react["default"].createElement(_Core.Selector, {
    style: {
      marginLeft: "5px"
    },
    dataTestId: "EnrichEditorUI.ConditionTypePopup.ClassifyTypeSelector",
    items: _constants.ConditionTypes,
    getKey: function getKey(type) {
      return type.key;
    },
    renderItemText: function renderItemText(type) {
      return type.displayName;
    },
    selected: (selectedType == null ? void 0 : selectedType.key) && [selectedType == null ? void 0 : selectedType.key],
    onSelect: function onSelect(_ref2) {
      var type = _ref2[0];
      return setSelectedType(type);
    },
    usePortal: false,
    itemPredicate: function itemPredicate(query, item) {
      return item.key.toLowerCase().indexOf(query.toLowerCase()) !== -1 || item.displayName.toLowerCase().indexOf(query.toLowerCase()) !== -1;
    }
  })), /*#__PURE__*/_react["default"].createElement(FooterButtons, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    className: "resetForm",
    minimal: true,
    onClick: function onClick() {
      return onClose();
    }
  }, translate("EnrichEditorUI.ConditionTypePopup.ClassifyType.CancelButton", "Cancel")), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    className: _core.Classes.POPOVER_DISMISS,
    type: "button",
    text: translate("EnrichEditorUI.ConditionTypePopup.ClassifyType.AddButton", "Add"),
    "data-testid": "EnrichEditorUI.ConditionTypePopup.ClassifyType.PopupAddButton",
    intent: _core.Intent.PRIMARY,
    onClick: function onClick() {
      (selectedType == null ? void 0 : selectedType.key) && setConditionArray([].concat(conditions, [{
        conditionType: selectedType.key
      }]));
      onClose();
    }
  })));
};